<template>
    <table-page
        @update:topBut="topBut"
        @update:nodeBut="nodeBut"
        ref="tablePageRef">
    </table-page>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, provide, reactive } from 'vue'
    import TablePage from '../../common/table'
    export default defineComponent({
        components: {
            TablePage
        },
        setup() {
            const { proxy } = getCurrentInstance()
            const selectIds = ref()
            const urls = proxy.$router.currentRoute.value.meta.urls
            const nodeBut = (e, data, index) => {
                if (e === 'Menus') {
                    proxy.$router.push({
                        path: '/operation/menu/index',
                        query: {
                            nid: data.id
                        }
                    })
                }
            }

            return {
                nodeBut
            }
        }
    })
</script>
<style>
</style>
